var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62.109,
    height: 62.109,
    viewBox: "0 0 62.109 62.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef",
    stopOpacity: 0.102
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.863 -12.863)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.863 12.863)",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 2,
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.055,
    cy: 31.055,
    r: 31.055,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.055,
    cy: 31.055,
    r: 30.055,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.314 18.611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-38.645-366.254a.755.755,0,0,1-.716.317.709.709,0,0,1-.565-1.032c.447-.958.925-1.9,1.426-2.831a.694.694,0,0,1,1.224.015c.491.921.951,1.859,1.4,2.8a.679.679,0,0,1-.193.893.716.716,0,0,1-.94-.042l-.12-.093a.61.61,0,0,0-.045.381q0,4.834,0,9.669c0,.514,0,.514.53.515.484,0,.969-.006,1.452,0a.7.7,0,0,1,.768.717.671.671,0,0,1-.76.708q-1.338.008-2.676,0a.651.651,0,0,1-.745-.641,4.866,4.866,0,0,1-.039-.647q0-4.968,0-9.937Z",
    transform: "translate(79.22 398.15)",
    fill: "rgba(255,255,255,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53.147-386.188a6.01,6.01,0,0,0,1.1-.738c.937-.987,2.045-.769,3.114-.436a3.541,3.541,0,0,1,2.479,3.454q.012,7.779,0,15.559a2.161,2.161,0,0,1-2.235,2.207c-.485,0-.97.023-1.453-.007-.367-.022-.447.126-.446.464q.014,5.142.006,10.283c0,.293.007.587,0,.88a.7.7,0,0,1-.714.772.706.706,0,0,1-.757-.732c-.011-.114-.007-.229-.007-.344q0-9.288,0-18.579a2.409,2.409,0,0,1,.026-.456.744.744,0,0,1,.728-.613.742.742,0,0,1,.7.6,2.312,2.312,0,0,1,.029.455q0,2.639,0,5.276c0,.52,0,.521.535.522.459,0,.918.006,1.377,0a.681.681,0,0,0,.716-.683c.007-.075.005-.152.005-.229q0-7.625,0-15.252a2.216,2.216,0,0,0-1.68-2.268,3.669,3.669,0,0,0-.874-.049c-.841-.007-1.682-.009-2.523-.015C-53.047-386.121-53.068-386.144-53.147-386.188Z",
    transform: "translate(78.521 397.668)",
    fill: "rgba(255,255,255,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-58.876-386.2a.551.551,0,0,1-.439.088c-.853.006-1.707-.005-2.561.007a2.1,2.1,0,0,0-2.135,2.134q-.015,7.778,0,15.556c0,.576.208.779.786.789.484.009.969-.011,1.452.008.321.012.417-.111.415-.423-.01-1.8-.005-3.594,0-5.39,0-.681.254-1.041.733-1.046s.749.377.749,1.042q0,9.345,0,18.69c0,.674-.238.987-.737.993a.672.672,0,0,1-.731-.627,3.23,3.23,0,0,1-.014-.457q0-5.39,0-10.779c0-.527,0-.527-.521-.528-.484,0-.968,0-1.453,0a2.154,2.154,0,0,1-2.153-2.13c-.015-1.133,0-2.268,0-3.4q0-6.078,0-12.154a3.623,3.623,0,0,1,3.533-3.757c.064,0,.128,0,.191-.005a1.87,1.87,0,0,1,1.691.547A7.488,7.488,0,0,0-58.876-386.2Z",
    transform: "translate(78.233 397.669)",
    fill: "rgba(255,255,255,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-43.229-382.635c-.136.086-.2.132-.263.165a.719.719,0,0,1-.853-.1.639.639,0,0,1-.184-.8c.457-.953.915-1.906,1.415-2.836a.724.724,0,0,1,1.284.017c.482.911.932,1.84,1.38,2.77a.662.662,0,0,1-.188.86c-.308.254-.639.221-1.114-.126v27.569a1.489,1.489,0,0,1-.148.814,1,1,0,0,1-.917.517c-1.72,0-3.44,0-5.16,0a.7.7,0,0,1-.748-.695A.712.712,0,0,1-48-355.2c.93-.013,1.86-.005,2.79-.006.535,0,1.071-.011,1.605,0,.289.009.4-.108.374-.382-.008-.088,0-.178,0-.267v-26.781Z",
    transform: "translate(78.556 397.697)",
    fill: "rgba(255,255,255,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-68.616-382.611a.729.729,0,0,0-.057.434q0,13.2,0,26.408c0,.56,0,.561.571.561h3.822c.114,0,.229,0,.343,0a.741.741,0,0,1,.752.75.7.7,0,0,1-.77.675c-1.605.006-3.21,0-4.815,0-.115,0-.229,0-.344,0a1.023,1.023,0,0,1-1.033-1.011c-.009-.165,0-.331,0-.5v-27.388c-.11.081-.175.139-.249.182a.711.711,0,0,1-.856-.046.641.641,0,0,1-.215-.821c.459-.965.924-1.93,1.43-2.871a.713.713,0,0,1,1.24.018c.5.929.963,1.882,1.419,2.835a.659.659,0,0,1-.2.829C-67.859-382.312-68.185-382.331-68.616-382.611Z",
    transform: "translate(78.154 397.697)",
    fill: "rgba(255,255,255,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-55.9-397.633a5.57,5.57,0,0,1,5.547,5.55,5.608,5.608,0,0,1-5.564,5.551,5.582,5.582,0,0,1-5.558-5.628A5.564,5.564,0,0,1-55.9-397.633Zm-.02,1.469a4.037,4.037,0,0,0-4.072,4.034,4.062,4.062,0,0,0,4.075,4.119,4.08,4.08,0,0,0,4.081-4.043A4.058,4.058,0,0,0-55.921-396.164Z",
    transform: "translate(78.318 397.633)",
    fill: "rgba(255,255,255,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-55.3-361.181q0,3,0,6c0,.587-.243.884-.707.9a.683.683,0,0,1-.753-.6,2.6,2.6,0,0,1-.021-.457q0-5.843,0-11.687c0-.115,0-.23.005-.344a.765.765,0,0,1,.722-.749.766.766,0,0,1,.751.76c.009.128.005.255.005.382Z",
    transform: "translate(78.447 398.206)",
    fill: "rgba(255,255,255,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-74.834-366.195a2.259,2.259,0,0,1-.384.222.709.709,0,0,1-.774-.185.663.663,0,0,1-.134-.781c.462-.964.932-1.927,1.436-2.87a.692.692,0,0,1,1.205,0c.5.929.973,1.877,1.43,2.83a.689.689,0,0,1-.209.894.715.715,0,0,1-.939-.058c-.037-.029-.077-.054-.122-.087a.769.769,0,0,0-.044.424q0,5.3,0,10.59c0,.809-.178.983-.991.983s-1.605,0-2.409,0c-.5,0-.775-.24-.786-.681a.692.692,0,0,1,.773-.745c.549-.009,1.1-.007,1.644,0,.211,0,.336-.045.336-.294q-.011-5.1-.011-10.207C-74.814-366.171-74.826-366.181-74.834-366.195Z",
    transform: "translate(77.556 398.15)",
    fill: "rgba(255,255,255,0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step3.aca078d3fa0f8cc3d09b0b982f6592d1.svg";
export { ForwardRef as ReactComponent };